import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { passwordErrorsArray } from '../../../commons/config';
import { GlobalFlagsService } from '../../../services/global-flags.service';
import { OAuthService } from '../../../services/oauth.service';
import { UserService } from '../../../services/user.service';


@Component({
  selector: 'app-dialog',
  templateUrl: './dialog-change-password.component.html',
  styleUrls: ['./dialog-change-password.component.scss']
})
export class DialogChangePassword implements OnInit {

  userDetails;
  passwordRules = passwordErrorsArray;

  constructor(
    public dialogRef: MatDialogRef<DialogChangePassword>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private globalFlagServices: GlobalFlagsService,
    private userService: UserService,
    private oAuthService: OAuthService) {
    }
    public registerAction=false;

  indexLoading = null;


  onNoClick(): void {
    this.dialogRef.close();
  }


  ngOnInit() {
    this.userDetails = this.data.userDetails;
  }


  checkPasswordError(passwordErrors, id) {
    for (const key in passwordErrors) {
      if (passwordErrors.hasOwnProperty(key)) {
        if (passwordErrors[key].id === id) {
          return 'invalid';
        }
      }
    }
  }


  changePassword(errors){

    if(
      errors ||
      this.userDetails.secMemberships[0].password === "" ||
      this.userDetails.secMemberships[0].oldPassword === "" ||
      this.userDetails.secMemberships[0].password !== this.userDetails.confirmPassword
      ){
        return false;
    } else {
        const confirmation = this.userService.changePassword(this.userDetails)
        confirmation
          .then((res: any) => {
            this.dialogRef.close();
            this.oAuthService.logout(null, true);
            window.location.reload();

          }, (err) => {
            alert("Current password is wrong. Please try again.")
          });
    }
  }
}
